import React, { useState } from "react";
import "../../Styles/Mp4.css";

const Videos = () => {
  const video = [
    {
      link: "https://www.youtube.com/embed/i3n4uTxi8Sk?si=23l81cc4ETnpioFm",
      videoId: "i3n4uTxi8Sk",
      title: "Development Works in Kandukur",
      channel: "Inturi Nageswara Rao",
      category: "New Song",
      time: "2 days ago",
      views: "12.5K",
      duration: "04:35",
    },
    {
      link: "https://www.youtube.com/embed/G0axauFJmVc?si=23l81cc4ETnpioFm",
      videoId: "G0axauFJmVc",
      title: "Kandukur Development Works",
      channel: "Political Box",
      category: "Mass Song",
      time: "5 days ago",
      views: "8.3K",
      duration: "04:12",
    },
    {
      link: "https://www.youtube.com/embed/R2N787ZPGBY?si=23l81cc4ETnpioFm",
      videoId: "R2N787ZPGBY",
      title: "Development Works in Kandukur",
      channel: "TV5 News",
      category: "TDP New Song",
      time: "1 week ago",
      views: "25.1K",
      duration: "03:48",
    },
    {
      link: "https://www.youtube.com/embed/LG9dJq9NOW0?si=23l81cc4ETnpioFm",
      videoId: "LG9dJq9NOW0",
      title: "Kandukur Development Works",
      channel: "Chandrababu Naidu",
      category: "Special Song",
      time: "1 month ago",
      views: "15.2K",
      duration: "04:20",
    },
    {
      link: "https://www.youtube.com/embed/ZmrCMyZTpgo?si=UkxGhQ1SZnRrMEeO",
      videoId: "ZmrCMyZTpgo",
      title: "Development Works in Kandukur",
      channel: "Dj Srivardhan Mixes",
      category: "DJ Song",
      time: "2 weeks ago",
      views: "10.7K",
      duration: "03:55",
    },
    {
      link: "https://www.youtube.com/embed/KiaLrGXdOB8?si=23l81cc4ETnpioFm",
      videoId: "KiaLrGXdOB8",
      title: "Kandukur Development Works",
      channel: "Telugu Desa Kavathu",
      category: "Campaign Song",
      time: "2 months ago",
      views: "22.5K",
      duration: "05:18",
    },
    {
      link: "https://www.youtube.com/embed/HNKYTcgphfc?si=23l81cc4ETnpioFm",
      videoId: "HNKYTcgphfc",
      title: "Development Works in Kandukur",
      channel: "Inturi Nageswara Rao",
      category: "New Song",
      time: "3 days ago",
      views: "9.4K",
      duration: "04:02",
    },
    {
      link: "https://www.youtube.com/embed/02dj6OYPbcA?si=3orEuIFlVYjcejsE",
      videoId: "02dj6OYPbcA",
      title: "Kandukur Development Works",
      channel: "Political Box",
      category: "Mass Song",
      time: "6 days ago",
      views: "7.8K",
      duration: "03:30",
    },
    {
      link: "https://www.youtube.com/embed/ZyHHd5UgGgk?si=23l81cc4ETnpioFm",
      videoId: "ZyHHd5UgGgk",
      title: "Development Works in Kandukur",
      channel: "TV5 News",
      category: "TDP New Song",
      time: "1 week ago",
      views: "18.9K",
      duration: "04:45",
    },
    {
      link: "https://www.youtube.com/embed/u9hRbU8r4D8?si=23l81cc4ETnpioFm",
      videoId: "u9hRbU8r4D8",
      title: "Kandukur Development Works",
      channel: "Chandrababu Naidu",
      category: "Special Song",
      time: "2 months ago",
      views: "13.6K",
      duration: "04:10",
    },
    {
      link: "https://www.youtube.com/embed/qu2b_wkSP2M?si=23l81cc4ETnpioFm",
      videoId: "qu2b_wkSP2M",
      title: "Development Works in Kandukur",
      channel: "Dj Srivardhan Mixes",
      category: "DJ Song",
      time: "3 weeks ago",
      views: "11.2K",
      duration: "03:40",
    },
    {
      link: "https://www.youtube.com/embed/h9L61GfWpUk?si=23l81cc4ETnpioFm",
      videoId: "h9L61GfWpUk",
      title: "Kandukur Development Works",
      channel: "Telugu Desa Kavathu",
      category: "Campaign Song",
      time: "1 month ago",
      views: "20.3K",
      duration: "05:02",
    },
    {
      link: "https://www.youtube.com/embed/bINdrsTtWo0?si=23l81cc4ETnpioFm",
      videoId: "bINdrsTtWo0",
      title: "Development Works in Kandukur",
      channel: "Inturi Nageswara Rao",
      category: "New Song",
      time: "4 days ago",
      views: "16.7K",
      duration: "04:28",
    },
    {
      link: "https://www.youtube.com/embed/i5brPz8vUPA?si=23l81cc4ETnpioFm",
      videoId: "i5brPz8vUPA",
      title: "Kandukur Development Works",
      channel: "Political Box",
      category: "Mass Song",
      time: "5 days ago",
      views: "8.9K",
      duration: "03:58",
    },
    {
      link: "https://www.youtube.com/embed/ONHOYkAM4v4?si=23l81cc4ETnpioFm",
      videoId: "ONHOYkAM4v4",
      title: "Development Works in Kandukur",
      channel: "TV5 News",
      category: "TDP New Song",
      time: "2 weeks ago",
      views: "14.1K",
      duration: "04:33",
    },
  ];

  const [activeTab, setActiveTab] = useState("All Videos");
  const [search, setSearch] = useState("");
  const [playingIndex, setPlayingIndex] = useState(null);
  const [likedVideos, setLikedVideos] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 6;

  const tabs = [
    { name: "All Videos", icon: "▶" },
    { name: "Songs", icon: "♫" },
    { name: "Campaigns", icon: "📣" },
    { name: "Events", icon: "📅" },
  ];

  const filteredVideos = video.filter((v) => {
    const matchesTab =
      activeTab === "All Videos" ||
      (activeTab === "Songs" && v.category.toLowerCase().includes("song")) ||
      (activeTab === "Campaigns" &&
        v.category.toLowerCase().includes("campaign")) ||
      (activeTab === "Events" && v.category.toLowerCase().includes("event"));
    const matchesSearch = v.title.toLowerCase().includes(search.toLowerCase());
    return matchesTab && matchesSearch;
  });

  const totalPages = Math.ceil(filteredVideos.length / videosPerPage);
  const startIndex = (currentPage - 1) * videosPerPage;
  const currentVideos = filteredVideos.slice(
    startIndex,
    startIndex + videosPerPage
  );

  const toggleLike = (index) => {
    setLikedVideos((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setCurrentPage(1);
  };

  return (
    <section className="video-gallery-section">
      <div className="video-container">
        {/* Heading */}
        <div className="vg-heading-wrap">
          <h1 className="vg-heading">Video Gallery</h1>
          <div className="vg-heading-underline">
            <span></span>
            <span className="vg-underline-dot">●</span>
            <span></span>
          </div>
          <p className="vg-subtitle">
            Watch and enjoy the latest songs, campaigns and highlights
          </p>
        </div>

        {/* Filters + Search */}
        <div className="vg-controls">
          <div className="vg-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                className={`vg-tab-btn ${
                  activeTab === tab.name ? "active" : ""
                }`}
                onClick={() => handleTabChange(tab.name)}
              >
                <span className="vg-tab-icon">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </div>

          <div className="vg-search">
            <span className="vg-search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search videos..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Grid */}
        <div className="vedios-grid">
          {currentVideos.map((v, index) => {
            const globalIndex = startIndex + index;
            const isPlaying = playingIndex === globalIndex;
            return (
              <div className="video-card" key={globalIndex}>
                <div className="videos">
                  {isPlaying ? (
                    <iframe
                      src={`${v.link}&autoplay=1`}
                      title={v.title}
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div
                      className="video-thumb"
                      onClick={() => setPlayingIndex(globalIndex)}
                    >
                      <img
                        src={`https://img.youtube.com/vi/${v.videoId}/hqdefault.jpg`}
                        alt={v.title}
                      />
                      <div className="thumb-overlay-top">
                        <span className="channel-avatar">
                          {v.channel.charAt(0)}
                        </span>
                        <span className="channel-name">{v.channel}</span>
                      </div>
                      <div className="play-btn-wrap">
                        <div className="play-btn">▶</div>
                      </div>
                      <div className="thumb-overlay-bottom">
                        <span>👁 {v.views}</span>
                        <span>{v.time}</span>
                      </div>
                      <span className="video-duration">{v.duration}</span>
                    </div>
                  )}
                </div>

                <div className="video-info">
                  <div className="video-info-top">
                    <h4 className="ved-cap">
                      Video {globalIndex + 1}
                    </h4>
                    <div className="video-actions">
                      <button
                        className={`like-btn ${
                          likedVideos.includes(globalIndex) ? "liked" : ""
                        }`}
                        onClick={() => toggleLike(globalIndex)}
                      >
                        {likedVideos.includes(globalIndex) ? "❤" : "♡"}
                      </button>
                      <div className="menu-wrap">
                        <button
                          className="menu-btn"
                          onClick={() =>
                            setOpenMenuIndex(
                              openMenuIndex === globalIndex
                                ? null
                                : globalIndex
                            )
                          }
                        >
                          ⋮
                        </button>
                        {openMenuIndex === globalIndex && (
                          <div className="menu-dropdown">
                            <button>Share</button>
                            <button>Download</button>
                            <button>Report</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="video-title-text">{v.title}</p>
                  <div className="video-meta-row">
                    <span className="video-category-tag">{v.category}</span>
                    <span className="video-time">{v.time}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredVideos.length === 0 && (
          <p className="no-results">No videos found.</p>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="vg-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            >
              ‹
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                className={currentPage === p ? "active" : ""}
                onClick={() => setCurrentPage(p)}
              >
                {p}
              </button>
            ))}
            <button
              disabled={currentPage === totalPages}
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, totalPages))
              }
            >
              ›
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Videos;